import { useLocation, useNavigate } from 'react-router-dom';
import { Phone, Mail, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS } from '../data/business';
import { DE_TO_EN, EN_TO_DE, isEnglishPath } from '../utils/i18nRoutes';

export default function TopInfoBar() {
  const { setLanguage } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location.pathname.replace(/\/$/, '') || '/';
  const onEnPage = isEnglishPath(currentPath);

  const switchLanguage = () => {
    const target = onEnPage
      ? (EN_TO_DE[currentPath] || '/')
      : (DE_TO_EN[currentPath] || '/en/');
    setLanguage(onEnPage ? 'de' : 'en');
    navigate(target);
  };

  return (
    <div className="bg-dark text-white text-sm">
      <div className="max-w-7xl mx-auto px-6 h-10 flex items-center justify-between">
        <span className="text-gray-300 text-center md:text-left text-xs md:text-sm w-full md:w-auto">
          {onEnPage
            ? 'Free initial consultation · Mon–Fri, 09:00–18:00'
            : 'Kostenloses Erstgespräch · Mo–Fr, 09:00–18:00 Uhr'}
        </span>
        <div className="hidden md:flex items-center gap-4">
          <a href={BUSINESS.phoneHref} className="flex items-center gap-1.5 text-gray-300 hover:text-white transition-colors">
            <Phone className="w-3.5 h-3.5" />
            {BUSINESS.phone}
          </a>
          <a href={BUSINESS.emailHref} className="flex items-center gap-1.5 text-gray-300 hover:text-white transition-colors">
            <Mail className="w-3.5 h-3.5" />
            {BUSINESS.email}
          </a>
          <button
            onClick={switchLanguage}
            className="flex items-center gap-1 text-gray-300 hover:text-white transition-colors font-medium"
            aria-label="Toggle language"
          >
            <Globe className="w-3.5 h-3.5" />
            <span className="font-semibold">{onEnPage ? 'DE' : 'EN'}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
